module.exports = {
      id: "sort-usage",
      viewBox: "0 0 6 8",
      url: "/" + "sprite-4add775381efce29ef76f223dff77c00.svg#sort",
      toString: function () {
        return this.url;
      }
    }